import './BreadcrumbSeparator.scss';

export const BreadcrumbSeparator = () => {
  return <span className="ant-breadcrumb-separator">/</span>;
};
